import React from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://243fa9515776683fae30ba17a92b2adb@o4511191000743936.ingest.us.sentry.io/4511191002644480",
  environment: process.env.NODE_ENV,
  sendDefaultPii: true,

  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  tracesSampleRate: 0.2,
  tracePropagationTargets: ["localhost"],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
